<template>
  <div class="topNav container-fluid">
    <div class="mobileInner">
      <div :class="{hidden: !isRoot}">
        <router-link to="/">
          <img :src="logo" class="topLogo" alt="" />
        </router-link>
      </div>
      <div :class="{hidden: isRoot}">
        <router-link to="/">
          <div class="textHome">
            <b-icon icon="chevron-left" scale="1" />
            <span> {{ pageName }} </span>
          </div>
        </router-link>
      </div>
      <div class="buttonLayer">
        <b-button squared variant="outline-white" v-b-toggle.sidebar-backdrop class="ham">
          <b-icon icon="list" font-scale="2" />
        </b-button>

        <b-sidebar id="sidebar-backdrop" backdrop no-shadow right width="90%" @shown="menuShown" @hidden="menuHidden">
          <div id="quest" class="menuContent" v-show="!isLogin">
            <div class="menuTop">
              <div class="menuTopHeader">
                <!--                <router-link class="roundBtn leftBtn" to="/"> 홈 </router-link>-->
                <!--                <router-link class="roundBtn rightBtn" to="/"> 닫기 </router-link>-->
              </div>

              <template>
                <a href="#"
                  ><span @click="langSelected('KOREAN')"><small>KOREAN</small></span> |
                </a>
                <a href="#"
                  ><span @click="langSelected('ENGLISH')"><small>ENGLISH</small></span> |
                </a>
                <!--                <a href="#"-->
                <!--                  ><span @click="langSelected('JAPANESE')"><small>JAPANESE</small></span></a-->
                <!--                >-->
              </template>

              <div class="text-center" v-show="isLang === 0">
                <span> 로그인 해주세요. </span>
              </div>

              <div class="menuTopMid text-center" v-show="isLang === 0">
                <router-link class="roundBtn item" to="/p/Login"> 로그인 </router-link>
                <router-link class="roundBtn item" to="/p/AuthSignupTerm"> 회원가입 </router-link>
                <!--                <router-link class="roundBtn item" to="/p/GuestReservResult"> 비회원 예약확인 </router-link>-->
              </div>
              <div class="menuTopBottom">
                <router-link class="roundBtn item" to="/"> HOME </router-link>
              </div>
              <div class="d-flex">
                <a href="https://pinxgc.thepinx.co.kr" class="roundBtn flex-grow-1"> PINX GC </a>
                <a href="https://podo.thepinx.co.kr" class="roundBtn flex-grow-1"> PODO </a>
                <a href="https://theannex.thepinx.co.kr" class="roundBtn flex-grow-1"> THE ANNEX </a>
                <a href="https://pleisure.thepinx.co.kr" class="roundBtn flex-grow-1"> P-LEISURE </a>
              </div>
            </div>
          </div>
          <div id="user" class="menuContent" v-show="isLogin">
            <div class="menuTop">
              <div class="menuTopHeader">
                <div class="selectUserContainer">
                  <b-form-select class="selectUser rounded-0 icon-chevron-down" v-model="changeMemNo">
                    <option v-for="(item, index) in optionMemSelect" :key="index" :value="item.value">
                      {{ item.text }}
                    </option>
                  </b-form-select>
                  <button
                    class="rangeSelectButton"
                    @click="updateSelectedMemNo"
                    :disabled="changeMemNo == selectedNumberMember"
                  >
                    적용
                  </button>
                </div>
              </div>
              <div class="text-center">
                <div>{{ userName }} 님 환영합니다.</div>
              </div>
              <div class="menuMidHeader text-center">
                <router-link class="roundBtn leftBtn" :to="{name: 'MyPage', params: {reservCategory: '포도호텔'}}">
                  마이페이지</router-link
                >
                <div class="roundBtn rightBtn" to="/" @click="logout">로그아웃</div>
              </div>
              <div class="menuTopBottom">
                <router-link class="roundBtn item" to="/"> HOME </router-link>
              </div>
              <div class="d-flex">
                <a href="https://pinxgc.thepinx.co.kr" class="roundBtn flex-grow-1"> PINX GC </a>
                <a href="https://theannex.thepinx.co.kr" class="roundBtn flex-grow-1"> THE ANNEX </a>
                <a href="https://pleisure.thepinx.co.kr" class="roundBtn flex-grow-1"> P-LEISURE </a>
              </div>
            </div>
          </div>
          <div>
            <ul class="headerMenu">
              <li
                v-for="(header, index) in headers"
                :key="index"
                @click="menuClick(index)"
                :class="{on: index === selectedSubmenuIndex}"
              >
                <a :href="header.topMenuLink" target="_self">
                  <!--                  <div>{{ header.topMenuLink }}</div>-->
                  <span>{{ header.topMenu }}</span>
                </a>
                <TransitionCollapseHeight v-show="index === selectedSubmenuIndex">
                  <ul class="depth2">
                    <li v-for="(sub, index2) in header.subMenu" :key="index2">
                      <router-link :to="sub.link">
                        <span>{{ sub.text }}</span>
                      </router-link>
                    </li>
                  </ul>
                </TransitionCollapseHeight>
              </li>
            </ul>
          </div>
        </b-sidebar>
      </div>
    </div>
  </div>
</template>

<script>
import TransitionCollapseHeight from '@/components/TransitionCollapseHeight';
import {RouteNameUtil} from '@/util/RouteNameUtil';
import GeneralUtil from '@/util/GeneralUtil';
export default {
  name: 'GnbTop',
  components: {TransitionCollapseHeight},
  props: {
    headers: Array,
    logo: String,
  },
  mixins: [GeneralUtil],
  data() {
    return {
      isRoot: false,
      selectedSubmenuIndex: -1,
      changeMemNo: 0,
      isLang: 0,
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters['Auth/isLoggedIn'];
    },
    loginUser() {
      return this.$store.getters['Auth/loginUser'];
    },
    userName() {
      if (this.loginUser) {
        return this.loginUser.guestName;
      } else {
        return '';
      }
    },
    pageName() {
      return this.$store.getters['Display/pageName'];
    },
    selectedNumberMember() {
      return this.$store.getters['Auth/selectedNumberMember'];
    },
    optionMemSelect() {
      if (this.loginUser) {
        if (this.loginUser.memInfoArr && this.loginUser.memInfoArr.length > 0) {
          console.log('aaa1', this.loginUser);
          return this.loginUser.memInfoArr.map((a, index) => ({
            value: index,
            text: a.memNo === 'X' ? this.loginUser.homepageGradeName : a.memTypeName + ` ` + a.memNo,
          }));
        } else {
          console.log('aaa2', this.loginUser);
          return null;
        }
      } else {
        console.log('aaa3', this.loginUser);
        return null;
      }
    },
    isShowChangeLang() {
      if (window.location.hostname.startsWith('localhost') || window.location.hostname.startsWith('devel-')) {
        return true;
      } else return false;
    },
  },
  watch: {
    $route(to, from) {
      this.isRoot = this.$route.path === '/';
    },
    selectedNumberMember(newValue, oldValue) {
      this.changeMemNo = newValue;
    },
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  mounted() {
    this.isRoot = this.$route.path === '/';
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  methods: {
    langSelected(lang) {
      this.selectedLanguage = lang;

      if (lang === 'KOREAN') {
        this.$root.$i18n.locale = 'ko';
      } else if (lang === 'ENGLISH') {
        this.$root.$i18n.locale = 'en';
      } else if (lang === 'JAPANESE') {
        this.$root.$i18n.locale = 'ja';
      }

      //언어 변경시 로그아웃후 메인페이지로 이동
      this.$store.dispatch('Auth/signOut', '');

      if (this.$router.currentRoute.path !== '/') {
        this.$router.replace('/');
      }
    },
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }
    },
    updateSelectedMemNo() {
      this.showMsgBoxConfirm('현재 고객 구분을 변경 하시겠습니까?', '회원구분 변경').then(value => {
        if (value === true) {
          this.$store.commit('Auth/updateSelectedNumberMemberInfo', this.changeMemNo);
        }
      });
    },
    menuClick(idx) {
      if (this.selectedSubmenuIndex === idx) {
        this.selectedSubmenuIndex = -1;
      } else {
        this.selectedSubmenuIndex = idx;
      }
    },
    menuShown() {
      document.documentElement.style.overflow = 'hidden';
    },
    menuHidden() {
      document.documentElement.style.overflow = 'auto';
    },

    async logout() {
      const confirm = await this.$bvModal.msgBoxConfirm('로그아웃하시겠습니까?', {
        title: '로그아웃',
        okVariant: 'primary',
        centered: true,
        okTitle: '확인',
        cancelTitle: '취소',
      });
      if (confirm) {
        this.$store.dispatch('Auth/signOut', '');

        if (this.$router.currentRoute.path !== '/') {
          this.$router.replace('/');
        }
      }
    },

    headerNameClick() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="scss">
/// RESET CSS
div,
ul,
li {
  margin: 0;
  padding: 0;
  border: 0;
  vertical-align: baseline;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  font-family: 'Noto Sans KR', sans-serif;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: '';
  content: none;
}

.hidden {
  display: none;
}

//
a {
  background: transparent;
  text-decoration: none;
  color: inherit;
}

.mobileInner {
  height: 5rem;
  line-height: 3rem;
  display: flex;
}

.topLogo {
  display: block;
  padding-left: 1rem;
  height: 2.5rem;
  margin-top: 1.1rem;
  box-sizing: border-box;
}

.buttonLayer {
  position: relative;
  margin-left: auto;
  margin-right: 0;
}

.ham {
  margin-top: 1rem;
}

// 상단 콘텐츠
.menuContent {
  height: auto;
  min-height: 10rem;
  display: block;
  text-align: center;
  .menuTop {
    background-color: #f9f9f9;
    display: block;
    .menuTopHeader {
      display: flex;
      .leftBtn {
      }
      .rightBtn {
        margin-left: auto;
      }
    }
    .menuTopMid {
      position: relative;
      display: inline-block;
      color: black;
      .item {
        margin-left: 0.2rem;
        margin-right: 0.2rem;
      }
    }
    .menuTopBottom {
      padding-top: 2rem;
      display: flex;
      .item {
        flex: 1;
      }
    }
  }

  .roundBtn {
    display: inline-block;
    min-width: 75px;
    padding: 7px 1.125em 8px;
    color: black;
    font: 400 13px/1 spoqaL;
    border: 1px solid #666;
    //border-radius: 25px;
  }
}

// 접이식 메뉴
.headerMenu {
  background-color: white;
  float: bottom;
  display: block;
}

.headerMenu > li {
  position: relative;
  float: none;
  display: block;
  font-size: 1rem;
  width: 100%;
  text-align: left;
  max-width: 100%;
}

.headerMenu > li > a {
  display: block;
  padding: 0.5rem 1rem;
  white-space: nowrap;
  color: #000;
  border-bottom: 1px solid #ebebeb;
  font-size: 1rem;
}

.headerMenu > li.on a > span:after {
  margin-top: 0.6rem;
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.depth2 {
}

.headerMenu > li > .depth2 li > a {
  color: #666;
  font-size: 1rem;
  display: block;
  padding: 0rem 1rem;
  border-bottom: 1px solid #ebebeb;
}

.headerMenu > li > a > span:after {
  display: block;
  content: '';
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 1rem;
  height: 1rem;
  content: '';
  border: solid #999;
  border-width: 0 1px 1px 0;
  margin: 0;
  transform: rotate(405deg);
  -webkit-transform: rotate(405deg);
}

.headerMenu > li.on a > span:after {
  top: 2.3rem;
  margin: 0;
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

///

.textHome {
  margin-top: 1rem;
  padding-left: 1rem;
  font-size: 1.4rem;
}

.gnbMenuLogin {
  .btnRound {
    display: inline-block;
    min-width: 85px;
    padding: 7px 1.125em 8px;
    color: #fff;
    font: 400 14px/1 spoqaL;
    border: 1px solid #666;
    //border-radius: 25px;
  }
}

//::v-deep .b-sidebar > .b-sidebar-header {
//  display: none !important;
//}
///////////////////////

.selectUserContainer {
  display: flex;
  width: 100%;
  padding-left: 0.2rem;
  padding-right: 0.2rem;
  .selectUser {
    flex: 3;
    height: 2rem;
    margin-right: 0.5rem;
    padding-bottom: inherit;
    padding-top: inherit;
  }

  .rangeSelectButton {
    flex: 1;
    align-items: center;
    vertical-align: middle;
    width: 100%;
    height: 100%;
    font-size: 0.8rem;
    line-height: 1.7rem;
    text-align: center;
    background-color: #af8c5e;
    padding: 0px;
    color: white;
    border: none;
    outline: none;
  }
}

@media (max-width: 992px) {
  .topNav {
    position: fixed;
    background-color: white;
    z-index: 10000;
    border-bottom: 1px solid #e5e5e5;
  }
}

@media (min-width: 992px) {
  .topNav {
    display: none;
  }
}
</style>
